import lessRequire from '../../config/less-require-resolver';
import PropTypes from 'prop-types';
import React from 'react';
import Clipboard from 'react-copy-to-clipboard';

lessRequire('modules/shared/copy-to-clipboard.less');

export default class Copy extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			isCopied: false,
			shouldShowTooltip: false
		};
	}

	render() {
		return (
			<Clipboard text={this.props.copyText} onCopy={this.onCopy.bind(this)}>
				<div className="copy-clipboard">
					<div
						className={`copy-clipboard__text ${this.props.disabled ? 'disabled' : ''}`}
						onMouseEnter={this.onShowTooltip.bind(this)}
						onMouseLeave={this.onHideTooltip.bind(this)}
					>
						{this.props.children}
					</div>
					{this.props.disabled
						? <div className="copy-clipboard__fader"></div>
						: <div className="copy-clipboard__action">
							{this.state.isCopied
								? <i className="copy-clipboard__copied">{this.props.intl('Скопировано')}</i>
								: <i className="copy-clipboard__active">{this.props.intl('Копировать')}</i>}
						</div>}
					{this.state.shouldShowTooltip &&
						this.props.tooltipText &&
						<div className="copy-clipboard__tooltip">
							<span className="copy-clipboard__tooltip-text">{this.props.tooltipText}</span>
						</div>}
				</div>
			</Clipboard>
		);
	}

	onCopy() {
		this.setState({
			isCopied: true,
			shouldShowTooltip: false
		});
		setTimeout(() => this.setState({ isCopied: false }), 1500);
	}

	onShowTooltip() {
		this.setState({ shouldShowTooltip: true });
	}

	onHideTooltip() {
		this.setState({ shouldShowTooltip: false });
	}
}

Copy.propTypes = {
	copyText: PropTypes.string,
	children: PropTypes.element,
	tooltipText: PropTypes.string,
	intl: PropTypes.func
};



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/shared/copy-to-clipboard.js